import React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { AdminIcon, type AdminIconName } from '../icons/AdminIcon';

export type AdminMenuEntry =
  | { key: string; label: string; icon: AdminIconName; onClick: () => void; danger?: boolean; disabled?: boolean }
  | { key: string; divider: true };

export interface AdminMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  items: AdminMenuEntry[];
  align?: 'left' | 'right';
}

export const AdminMenu: React.FC<AdminMenuProps> = ({ anchorEl, onClose, items, align = 'right' }) => (
  <Menu
    open={!!anchorEl}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: align }}
    transformOrigin={{ vertical: 'top', horizontal: align }}
    slotProps={{ paper: { sx: { minWidth: 240 } } }}
  >
    {items.map((it) => ('divider' in it
      ? <Divider key={it.key} sx={{ my: '4px !important' }} />
      : (
        <MenuItem key={it.key} disabled={it.disabled} onClick={() => { onClose(); it.onClick(); }} sx={{ color: it.danger ? 'error.main' : 'text.primary' }}>
          <Box sx={{ display: 'flex', color: it.danger ? 'error.main' : 'text.secondary' }}><AdminIcon name={it.icon} size={16} /></Box>
          {it.label}
        </MenuItem>
      )))}
  </Menu>
);

export default AdminMenu;
